module.exports = __webpack_public_path__ + "img/oppo-ax7.408f4536.png";